import { Button, Input } from "reactstrap";
import TopMenuBar from "./TopMenuBar";
import "../../../assets/css/lateral_bar.css";
import { MdDelete, MdEdit, MdEditOff, MdInput } from "react-icons/md";
import DynamicParam from "../../../components/Workflow/DynamicParam";
import { useEffect, useState } from "react";

import ParametrosDeEntrada from "./ParametroDeEntrada";

export function LateralBar({
  width,
  node,
  onCloseButton,
  minNumberHeight,
  options,
  onParamChange,
  onNodeNameChange,
  onRemoveNode,
  onChangeNode,
  onRefreshParams,
}) {
  const [visibleEditMode, setVisibleEditMode] = useState(false);

  const { data } = node ?? { data: null };

  useEffect(() => {
    setVisibleEditMode(false);
  }, [node]);

  const parametrosDeSaida = node?.params
    ?.filter((e) => e.type === "output")
    .map((e, index) => (
      <div className="parametro-saida" key={e.id}>
        <div>
          <span
            style={{ fontStyle: "italic", fontSize: 10 }}
            className="parametro-badge"
          >
            {e.label}
          </span>
        </div>
      </div>
    ));

  const hasEntrada =
    node?.params?.filter((e) => e.type === "input")?.length > 0;

  return (
    <div
      style={{
        width: `${width}px`,
        overflowY: "auto",
      }}
      className="parametro-div"
    >
      <TopMenuBar
        title={node ? data?.type?.title : ""}
        readonly={true}
        closed={width === minNumberHeight}
        closeButton={true}
        onCloseButton={onCloseButton}
      />
      {width > minNumberHeight ? (
        <div className="lateral-bar-content" style={{ width }}>
          <div className="parametro-container default-itens">
            <span className="parametro-header">Configurações Gerais:</span>
            <div className="parametro-item mt-1">
              <label className="parametro-label">Nome da Função</label>
              <Input
                maxLength={60}
                value={data?.title}
                onChange={({ target }) =>
                  onNodeNameChange(node.id, target.value)
                }
              />
            </div>
          </div>
          {hasEntrada && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <span className="parametro-header">Parâmetros de Entrada:</span>
                {visibleEditMode && <div />}
                {visibleEditMode && (
                  <span
                    style={{
                      fontSize: 10,
                      color: "var(--bs-danger)",
                      fontWeight: "500",
                      fontStyle: "italic",
                    }}
                  >
                    Este modo permite editar os tipos associados a cada
                    parâmetro.
                  </span>
                )}
              </div>
              <div>
                <Button
                  size="sm"
                  color={visibleEditMode ? "secondary" : "primary"}
                  active={visibleEditMode}
                  onClick={() => setVisibleEditMode(!visibleEditMode)}
                >
                  {visibleEditMode ? <MdEditOff /> : <MdEdit />}
                </Button>
              </div>
            </div>
          )}

          <ParametrosDeEntrada
            node={node}
            onParamChange={onParamChange}
            options={options}
            onChangeNode={onChangeNode}
            onRefreshParams={onRefreshParams}
            visibleEditMode={visibleEditMode}
          />
          {hasEntrada && <div style={{ height: 15 }} />}
          {parametrosDeSaida?.length > 0 && (
            <span className="parametro-header">Saída da Função:</span>
          )}
          <div>{parametrosDeSaida}</div>

          <div style={{ marginTop: 30, marginLeft: 5 }}>
            <Button
              color="danger"
              onClick={() => onRemoveNode(node.id)}
              size="sm"
            >
              <MdDelete /> Remover Função
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
